import React from 'react';
import { ArrowRight, Star, ShieldCheck, Mail } from 'lucide-react';
export function FinalCTA() {
  return <section className="bg-gradient-to-b from-volley-navy to-volley-navy-dark py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-71">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-volley-teal/10 rounded-full blur-3xl pointer-events-none" data-id="element-72"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-volley-orange/10 rounded-full blur-3xl pointer-events-none" data-id="element-73"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-74">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 text-white font-semibold text-xs px-4 py-1.5 rounded-full mb-8 inline-block uppercase tracking-[0.2em]" data-id="element-75">
          L'ULTIMA OCCASIONE
        </div>

        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-tight mb-6 tracking-tight" data-id="element-76">
          I tuoi atleti meritano la versione migliore di te, non una{' '}
          <span className="italic text-volley-orange" data-id="element-77">versione esausta</span>.
        </h2>

        <p className="text-white/85 text-lg mb-12 max-w-xl mx-auto leading-relaxed" data-id="element-78">
          Smetti di passare le tue domeniche a pianificare. Riprendi il
          controllo della tua carriera con strumenti d'élite al prezzo di una
          pizza.
        </p>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 mb-8 max-w-sm mx-auto shadow-2xl" data-id="element-79">
          <p className="text-white/80 text-sm mb-2 font-medium" data-id="element-80">
            Pack 6-in-1: Volley Pronto + 5 Bonus di Lusso
          </p>
          <p className="text-white/60 text-sm mb-1" data-id="element-81">
            <span className="line-through" data-id="element-82">€97 EUR</span>
          </p>
          <p className="text-white/90 text-base mb-1 font-medium" data-id="element-83">Solo:</p>
          <p className="font-display text-7xl sm:text-8xl font-semibold text-white leading-none tracking-tight" data-id="element-84">
            €19
          </p>
        </div>

        <a href="https://pilates-ready.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-volley-orange to-volley-orange-dark text-white font-semibold text-base sm:text-lg py-4 px-8 sm:px-12 rounded-full shadow-[0_15px_40px_rgba(238,122,35,0.4)] hover:shadow-[0_20px_50px_rgba(238,122,35,0.6)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-85">
          <span data-id="element-86">🚀 SÌ, VOGLIO IL MIO PACCHETTO VOLLEY PRONTO</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-87" />
        </a>

        <div className="mt-10 flex flex-col items-center gap-3" data-id="element-88">
          <div className="flex items-center gap-2 text-white/90 text-sm font-medium" data-id="element-89">
            <Mail className="w-4 h-4 text-volley-orange" data-id="element-90" />
            <span data-id="element-91">Accesso Immediato — Consegna via Email</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-92">
            <div className="flex text-volley-yellow" data-id="element-93">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-94" />)}
            </div>
            <span className="text-white/90 text-sm font-medium" data-id="element-95">
              4.9/5 — Recensioni Professionali Verificate
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm" data-id="element-96">
            <ShieldCheck className="w-4 h-4 text-volley-teal" data-id="element-97" />
            <span data-id="element-98">Garanzia 7 Giorni — Zero Rischi</span>
          </div>
        </div>
      </div>
    </section>;
}